import { NgModule } from '@angular/core';
import { ColumnSelectorComponent } from './column-selector/column-selector.component';
import { SmartColumnComponent } from './smart-column/smart-column.component';
import { SmartSearchInputComponent } from './smart-search-input/smart-search-input.component';
import { SmartColumnFilterComponent } from './smart-column-filter/smart-column-filter.component';
import { SmartTableDirective } from './smart-table.directive';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { SmartCellComponent } from './smart-cell/smart-cell.component';
import { TranslateModule } from '@ngx-translate/core';
import { DateRangeFilterComponent } from './date-range-filter/date-range-filter.component';
import { SmartClearFiltersComponent } from './smart-clear-filters/smart-clear-filters.component';
import { ControlsModule } from '../controls/controls.module';

@NgModule({
	declarations: [
		SmartTableDirective,
		ColumnSelectorComponent,
		SmartColumnComponent,
		SmartCellComponent,
		SmartSearchInputComponent,
		SmartColumnFilterComponent,
		DateRangeFilterComponent,
		SmartClearFiltersComponent,
	],
	imports: [FormsModule, CommonModule, TranslateModule, ControlsModule],
	providers: [],
	exports: [
		SmartTableDirective,
		ColumnSelectorComponent,
		SmartColumnComponent,
		SmartCellComponent,
		SmartSearchInputComponent,
		SmartColumnFilterComponent,
		DateRangeFilterComponent,
		SmartClearFiltersComponent,
	],
})
export class SmartTableModule {}

export * from './smart-table.directive';
export * from './smart-table.service';
export * from './smart-search-input/smart-search-input.component';
export * from './smart-column-filter/smart-column-filter.component';
export * from './date-range-filter/date-range-filter.component';
export * from './smart-column/smart-column.component';
export * from './smart-cell/smart-cell.component';
export * from './column-selector/column-selector.component';
export * from './smart-table-consumer';
export * from './smart-clear-filters/smart-clear-filters.component';
export * from './local-data.service';
